/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module _document
 */

export default (typeof document === 'undefined' ? void 0 : document);
